/**
 * Dashboard language <-> platform locale.
 *
 * The dashboard's translation catalogue is keyed by short language
 * codes (`en`, `es`); the backend stores `preferredLanguage` as a
 * platform locale spelled exactly `en_US` / `es_US` (case-sensitive,
 * anything else is a 422). This is the ONE place that knows both
 * spellings, so neither side's naming leaks into the other.
 *
 * Only locales the dashboard actually ships translations for are
 * listed; a backend value outside this map (e.g. `ht`, `vi_VN`) maps
 * to null and the client keeps its current language.
 */
const LOCALE_BY_LANGUAGE = {
  en: 'en_US',
  es: 'es_US',
};

const LANGUAGE_BY_LOCALE = Object.entries(LOCALE_BY_LANGUAGE).reduce((acc, [lang, locale]) => {
  acc[locale] = lang;
  return acc;
}, {});

export const toBackendLocale = language => LOCALE_BY_LANGUAGE[language] || null;

export const fromBackendLocale = locale => LANGUAGE_BY_LOCALE[locale] || null;
